import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Navbar, Footer } from "../../components/Layout";
import { toast, Toaster } from "sonner";
import { Plus, Edit, Trash2, Copy, ExternalLink, ArrowLeft, Eye, EyeOff } from "lucide-react";

export default function PagesAdmin() {
  const [pages, setPages] = useState([]);
  const navigate = useNavigate();

  const load = () => api.get("/admin/pages").then(r => setPages(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!confirm("Supprimer cette page ?")) return;
    await api.delete(`/admin/pages/${id}`);
    toast.success("Page supprimée");
    load();
  };
  const dup = async (id) => {
    await api.post(`/admin/pages/${id}/duplicate`);
    toast.success("Page dupliquée");
    load();
  };
  const togglePublished = async (p) => {
    await api.put(`/admin/pages/${p.id}`, { published: !p.published });
    load();
  };
  const toggleMenu = async (p) => {
    await api.put(`/admin/pages/${p.id}`, { in_menu: !p.in_menu });
    load();
  };
  const move = async (p, dir) => {
    await api.put(`/admin/pages/${p.id}`, { menu_order: (p.menu_order || 100) + (dir === "up" ? -10 : 10) });
    load();
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <Toaster richColors position="top-right" />
      <section className="max-w-7xl mx-auto px-6 md:px-8 py-12">
        <Link to="/admin" className="text-xs font-bold uppercase tracking-widest text-slate-500 hover:text-slate-900 mb-6 inline-flex items-center gap-2"><ArrowLeft className="w-3 h-3"/> Retour</Link>
        <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
          <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Pages du site</h1>
          <Link to="/admin/pages/nouvelle" data-testid="add-page-btn" className="btn-brutal btn-brutal-solar px-5 py-3 font-bold uppercase tracking-wider text-sm flex items-center gap-2"><Plus className="w-4 h-4"/>Nouvelle page</Link>
        </div>

        <div className="bg-white border border-slate-900/15 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-900 text-white">
              <tr><Th>Titre</Th><Th>Slug</Th><Th>Menu</Th><Th>Ordre</Th><Th>Publiée</Th><Th className="text-right">Actions</Th></tr>
            </thead>
            <tbody>
              {pages.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-slate-500 font-mono">Aucune page personnalisée. Créez votre première page.</td></tr>}
              {pages.map(p => (
                <tr key={p.id} className="border-t border-slate-900/10" data-testid={`row-page-${p.id}`}>
                  <td className="px-4 py-3 font-semibold">{p.title}</td>
                  <td className="px-4 py-3 font-mono text-xs">/p/{p.slug}</td>
                  <td className="px-4 py-3"><button onClick={() => toggleMenu(p)} className="text-xs underline">{p.in_menu ? "Oui" : "Non"}</button></td>
                  <td className="px-4 py-3 font-mono text-xs">
                    <div className="flex gap-1 items-center">
                      <button onClick={() => move(p, "up")} className="border border-slate-900 w-6 h-6 hover:bg-slate-900 hover:text-white">↑</button>
                      <span className="px-2">{p.menu_order || 100}</span>
                      <button onClick={() => move(p, "down")} className="border border-slate-900 w-6 h-6 hover:bg-slate-900 hover:text-white">↓</button>
                    </div>
                  </td>
                  <td className="px-4 py-3"><button onClick={() => togglePublished(p)} className="p-1 border border-slate-900 hover:bg-slate-900 hover:text-white">{p.published ? <Eye className="w-4 h-4"/> : <EyeOff className="w-4 h-4"/>}</button></td>
                  <td className="px-4 py-3 text-right flex justify-end gap-2">
                    <a href={`/p/${p.slug}`} target="_blank" rel="noreferrer" className="p-2 border border-slate-900 hover:bg-slate-900 hover:text-white"><ExternalLink className="w-4 h-4"/></a>
                    <button onClick={() => dup(p.id)} className="p-2 border border-slate-900 hover:bg-slate-900 hover:text-white" data-testid={`dup-${p.id}`}><Copy className="w-4 h-4"/></button>
                    <button onClick={() => navigate(`/admin/pages/${p.id}/edit`)} className="p-2 border border-slate-900 hover:bg-slate-900 hover:text-white" data-testid={`edit-page-${p.id}`}><Edit className="w-4 h-4"/></button>
                    <button onClick={() => del(p.id)} className="p-2 border border-slate-900 hover:bg-red-600 hover:text-white hover:border-red-600" data-testid={`del-page-${p.id}`}><Trash2 className="w-4 h-4"/></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      <Footer />
    </div>
  );
}

const Th = ({ children, className = "" }) => (
  <th className={`px-4 py-3 text-left text-xs font-bold uppercase tracking-widest ${className}`}>{children}</th>
);
